import { render, staticRenderFns } from "./EmailDialog.vue?vue&type=template&id=3fa38c53&scoped=true"
import script from "./EmailDialog.vue?vue&type=script&lang=js"
export * from "./EmailDialog.vue?vue&type=script&lang=js"
import style0 from "./EmailDialog.vue?vue&type=style&index=0&id=3fa38c53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa38c53",
  null
  
)

export default component.exports